import {load, register} from '@shopify/theme-sections';
import {productSection} from '../components/product';
import '../sections/upsell';

// Register product section
register('product', productSection);

// Load all registered sections
load('*');
